import { Text, View } from "@react-pdf/renderer";
import { CellTextBoxNoBorder, styles } from "../reportingHelpers";
import { formatAttendance } from "../utils";

export const ScoringTable = ({
  fixture,
  intl,
  homeTeam,
  awayTeam,
  homeTeamPeriods,
  awayTeamPeriods,
  fixtureProfile,
}) => {
  let d = new Date(fixture.startTimeLocal),
    year = d.getFullYear(),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    hours = d.getHours(),
    minutes = d.getMinutes();
  if (month.length < 2) {
    month = "0" + month;
  }
  if (day.length < 2) {
    day = "0" + day;
  }
  if (hours.length < 2) {
    hours = "0" + hours;
  }
  if (minutes.length < 2) {
    minutes = "0" + minutes;
  }

  const intervalLength = fixtureProfile.periodLength / 2.0;
  const periodLabels = Array.from(
    { length: fixtureProfile.numberOfPeriods * 2 },
    (value, index) => (index + 1) * intervalLength
  );
  periodLabels.push(
    intl.formatMessage({
      id: "reports.boxscore.overtimeShort",
      defaultMessage: "O",
    })
  );

  return (
    <View style={{ flexDirection: "column", width: "95mm", marginRight: 25 }}>
      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "95mm",
          border: "none",
        }}
      >
        <CellTextBoxNoBorder
          style={{
            width: "35%",
            height: "4mm",
            textAlign: "left",
            paddingLeft: 2,
          }}
        >
          <Text style={{ fontWeight: "bold" }}>
            {intl.formatMessage({
              id: "date",
              defaultMessage: "Date",
            })}
            :
          </Text>{" "}
          {`${day}/${month}/${year}`}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{
            width: "65%",
            height: "4mm",
            textAlign: "left",
            paddingLeft: 2,
          }}
        >
          <Text style={{ fontWeight: "bold" }}>
            {intl.formatMessage({
              id: "time",
              defaultMessage: "Time",
            })}
            :
          </Text>{" "}
          {`${hours}${minutes}`}
        </CellTextBoxNoBorder>
      </View>

      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "95mm",
          border: "none",
        }}
      >
        <CellTextBoxNoBorder
          style={{
            width: "50%",
            height: "4mm",
            textAlign: "left",
            paddingLeft: 2,
          }}
        >
          <Text style={{ fontWeight: "bold" }}>
            {intl.formatMessage({
              id: "reports.boxscore.attendance",
              defaultMessage: "Attendance",
            })}
            :
          </Text>{" "}
          {formatAttendance(fixture.attendance)}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ width: "50%", height: "4mm" }}>
          <Text
            style={{ fontWeight: "bold", textAlign: "left", paddingLeft: 2 }}
          >
            {intl.formatMessage({
              id: "reports.boxscore.played",
              defaultMessage: "Played",
            })}
            :
          </Text>
        </CellTextBoxNoBorder>
      </View>

      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "95mm",
        }}
      >
        <CellTextBoxNoBorder
          style={{
            height: "4mm",
            width: "25mm",
            textAlign: "left",
            paddingLeft: 2,
            borderBottomWidth: 1,
            borderRightWidth: 1,
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.teammin",
            defaultMessage: "Team/Min",
          })}
        </CellTextBoxNoBorder>
        {periodLabels.map((periodLabel, index) => (
          <CellTextBoxNoBorder
            key={`scoring-period-label-${index}`}
            style={{
              height: "4mm",
              borderBottomWidth: 1,
              borderRightWidth: index === periodLabels.length - 1 ? 0 : 1,
            }}
          >
            {periodLabel}
          </CellTextBoxNoBorder>
        ))}
      </View>
      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "95mm",
        }}
      >
        <CellTextBoxNoBorder
          style={{
            height: "4mm",
            width: "25mm",
            textAlign: "left",
            paddingLeft: 2,
            borderRightWidth: 1,
          }}
        >
          {homeTeam.name}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[0]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[0]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[1]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[1]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[2]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[2]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[3]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          style={{ height: "4mm", fontWeight: "bold", borderRightWidth: 1 }}
        >
          {homeTeamPeriods[3]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder
          noDot={true}
          style={{
            height: "4mm",
            fontWeight: "bold",
          }}
        >
          {homeTeamPeriods.filter((p) => p.isOverTime).length
            ? Math.max(
                ...homeTeamPeriods
                  .filter((p) => p.isOverTime)
                  .map((p) => p.interval1)
              )
            : ""}
        </CellTextBoxNoBorder>
      </View>
      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "95mm",
        }}
      >
        <CellTextBoxNoBorder
          style={{
            height: "4mm",
            width: "25mm",
            textAlign: "left",
            paddingLeft: 2,
            borderRightWidth: 1,
          }}
        >
          {awayTeam.name}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[0]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[0]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[1]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[1]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[2]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[2]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[3]?.interval1}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder style={{ height: "4mm", borderRightWidth: 1 }}>
          {awayTeamPeriods[3]?.interval2}
        </CellTextBoxNoBorder>
        <CellTextBoxNoBorder noDot={true} style={{ height: "4mm" }}>
          {awayTeamPeriods.filter((p) => p.isOverTime).length
            ? Math.max(
                ...awayTeamPeriods
                  .filter((p) => p.isOverTime)
                  .map((p) => p.interval1)
              )
            : ""}
        </CellTextBoxNoBorder>
      </View>
    </View>
    /* todo map over home and away teams*/
  );
};
